document.addEventListener('DOMContentLoaded', function() {
    var elements = document.querySelectorAll('.story_section');
    
    function checkIfVisible() {
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var elementPosition = element.getBoundingClientRect().top;
        var windowHeight = window.innerHeight;
        
        if (elementPosition < windowHeight) {
          element.classList.add('is-visible');
        } else {
          element.classList.remove('is-visible');
        }
      }
    }
    
    function handleScroll() {
      checkIfVisible();
    }
    
    // ページ読み込み時とスクロール時にチェックを実行する
    window.addEventListener('DOMContentLoaded', checkIfVisible);
    window.addEventListener('scroll', handleScroll);
  });
